import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { global } from './reducer';

const initGlobalState = {
  isShowingStatusBanner: true,
};

export const GlobalContext = createContext(initGlobalState);

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(global?.GlobalReducer, initGlobalState);

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in global?.actions) {
    boundActions[key] = global.actions[key](dispatch);
  }

  return (
    <GlobalContext.Provider value={{ state, ...boundActions }}>{children}</GlobalContext.Provider>
  );
};

GlobalProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
